import { compose, map } from 'ramda';
import { decapitalizeFirst, joinWithDot, splitByDot } from 'ramda-extension';

export const decapitalizeFirstWithDot: (value: string) => string = compose(
	joinWithDot,
	map(decapitalizeFirst),
	splitByDot
);
